export const firebaseConfig = {
  apiKey: 'AIzaSyAlbDVkC3g9SNc6x2FUM54rjVmk2_oXjFA',
  authDomain: 'axels-chat.firebaseapp.com',
  projectId: 'axels-chat',
  storageBucket: 'axels-chat.appspot.com',
  messagingSenderId: '1005422681509',
  appId: '1:1005422681509:web:b3d866edf13e2d3e8a9c4c',
};
